import { StreamTokenClaims } from './StreamToken'

const decodeBase64Url = (value: string): string => {
    const base64 = value.replace(/-/g, '+').replace(/_/g, '/')
    const padded = base64.padEnd(base64.length + ((4 - (base64.length % 4)) % 4), '=')

    return atob(padded)
}

/**
 * Reads (without verifying) the claims of a Stream user token. Stream tokens are JWTs carrying the
 * `user_id` they were minted for, so this is the source of truth for which Stream user to connect as.
 */
export const getStreamTokenClaims = (token: string): StreamTokenClaims | undefined => {
    try {
        const [, payload] = token.split('.')
        const claims: { user_id?: unknown, exp?: unknown } = JSON.parse(decodeBase64Url(payload))

        if (typeof claims.user_id !== 'string' || ! claims.user_id) {
            return undefined
        }

        return {
            userId: claims.user_id,
            expiresAt: typeof claims.exp === 'number' ? new Date(claims.exp * 1000) : undefined,
        }
    } catch {
        return undefined
    }
}

export const isStreamTokenExpired = (claims: StreamTokenClaims, marginInSeconds = 60, now = new Date()): boolean => (
    !! claims.expiresAt && claims.expiresAt.getTime() - (marginInSeconds * 1000) <= now.getTime()
)
